var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOk = function SvgIconOk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 0c11.598 0 21 9.402 21 21s-9.402 21-21 21S0 32.598 0 21 9.402 0 21 0m14.02 11.737a2.515 2.515 0 0 0-3.558 0l-13.643 13.64-6.524-6.523a2.516 2.516 0 1 0-3.558 3.558l8.288 8.288.016.017a2.516 2.516 0 0 0 3.558 0l15.42-15.422a2.515 2.515 0 0 0 0-3.558"
  })));
};
export default SvgIconOk;